import { Button } from "@nimit9/signet-ui/components/button"
import { Input } from "@nimit9/signet-ui/components/input"
import { Lock } from "lucide-react"

const BANK_HINTS: Record<string, string> = {
  hdfc: "For HDFC, it's usually your customer ID followed by DOB (DDMM).",
  sbi: "For SBI, try your account number (last 6 digits) or date of birth.",
  icici: "For ICICI, try your customer ID.",
  amex: "For Amex, try your 4-digit card PIN.",
}

interface StepPasswordProps {
  fileName: string
  detectedBank?: string
  password: string
  passwordError: string | null
  isParsing: boolean
  onChange: (v: string) => void
  onSubmit: (e: React.FormEvent) => void
  onCancel: () => void
}

export function StepPassword({
  fileName,
  detectedBank,
  password,
  passwordError,
  isParsing,
  onChange,
  onSubmit,
  onCancel,
}: StepPasswordProps) {
  const hint = detectedBank ? BANK_HINTS[detectedBank.toLowerCase()] : null

  return (
    <div className="flex-1 overflow-y-auto px-6 py-6">
      <div
        className="mb-4 flex size-11 items-center justify-center rounded-[12px] border"
        style={{
          background: "rgba(245,158,11,0.10)",
          borderColor: "rgba(245,158,11,0.22)",
        }}
      >
        <Lock className="size-5 text-accent-amber" strokeWidth={2} />
      </div>

      <h3 className="text-[17px] font-bold tracking-tight text-text-primary">Unlock this PDF</h3>
      <p className="mt-2 text-[12.5px] leading-relaxed text-text-muted">
        <span className="font-mono text-text-primary">{fileName}</span> is password-protected. Paisa
        unlocks it here on your device — the password never leaves your browser.
      </p>

      <form onSubmit={onSubmit} className="mt-5 space-y-3">
        <Input
          type="password"
          autoFocus
          value={password}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
          placeholder="Enter PDF password"
          className="font-mono tracking-widest"
        />
        {passwordError && <p className="text-[12px] text-accent-red">{passwordError}</p>}
        {hint && !passwordError && (
          <p className="text-[11px] text-text-muted leading-relaxed">{hint}</p>
        )}

        <div className="flex gap-2 pt-1">
          <Button type="submit" disabled={!password || isParsing} className="flex-1">
            {isParsing ? "Unlocking…" : "Unlock"}
          </Button>
          <Button type="button" variant="ghost" onClick={onCancel} className="flex-1">
            Cancel
          </Button>
        </div>
      </form>
    </div>
  )
}
